<ng-container *ngIf="operation$ | async as operation">
  <app-table-suivis
    [source]="suivis$ | async"
    (add)="onAdd($event, operation)"
    (update)="onUpdate($event, operation)"
    (delete)="onDelete($event, operation)"
  ></app-table-suivis>
</ng-container>
